export default __webpack_public_path__ + "static/media/company.99f3b822.jpg";